import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { listSchemaNames } from '@core-engine/schema/schema-reader/list-schema-names.js'
import { loadSchema } from '@core-engine/schema/schema-reader/load-schema.js'
import { loadSchemaOwnershipIndex } from '@preset-engine/ownership/load-schema-ownership-index.js'
import { collectSchemaRelationshipTargets } from './collect-schema-relationship-targets.js'
import { getSchemasDir } from './get-schemas-dir.js'

export function findBlockingSchemaDependencies(
  cwd: string,
  config: ResolvedBetterstartConfig,
  ownedSchemas: string[]
): string[] {
  const blockers: string[] = []
  const schemasDir = getSchemasDir(cwd, config)
  const ownership = loadSchemaOwnershipIndex(cwd)

  for (const schemaName of listSchemaNames(schemasDir)) {
    if (ownership.schemas[schemaName] !== 'user') {
      continue
    }

    const loaded = loadSchema(schemasDir, schemaName)
    const relationshipTargets = collectSchemaRelationshipTargets(loaded).filter((target) =>
      ownedSchemas.includes(target)
    )

    if (relationshipTargets.length > 0) {
      blockers.push(
        `${schemaName} references preset-owned schema(s): ${relationshipTargets.join(', ')}`
      )
    }
  }

  return blockers
}
